// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/lock-closed.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/lock-closed'

import { Icon, type IconComponentProps } from '../icon'

export const LockClosedIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
